import {Component, OnInit} from '@angular/core';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MyBusiness} from '../../../models/my-business';
import {PaylinkSubscription} from '../../../models/paylink-subscription';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../../services/environment.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {MerchantPaylinkPaymentResponse} from '../../../models/merchant-paylink-payment-response';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;
declare var $: any;

@Component({
  selector: 'app-process-sub-account-payment',
  templateUrl: './process-sub-account-payment.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./process-sub-account-payment.component.scss']
})
export class ProcessSubAccountPaymentComponent implements OnInit {

  loading: any;
  form: FormGroup;
  lang: any;
  submitted: boolean;
  myBusiness: MyBusiness;
  submitting: boolean;
  selectedSubscription: PaylinkSubscription;

  constructor(private loader: GlobalLoaderService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private translate: TranslateService,
              private env: EnvironmentService,
              private api: ApiAgentService) {
  }

  get f() {
    return this.form.controls;
  }

  get v() {
    return this.form.value;
  }

  private async loadResources() {
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loader.loadExternalScript('/plugins/blockui/jquery.blockUI.min.js');
  }


  async ngOnInit() {
    this.submitting = false;
    this.loading = true;

    setTimeout(async () => {
      await this.loadResources();
      this.lang = await this.translate.get('lang').toPromise();
      this.loading = false;
      await this.processPayment();
    }, 1000);

  }

  async processPayment() {
    try {
      let orderNumber = this.activatedRoute.snapshot.queryParams['orderNumber'];
      let transactionNo = this.activatedRoute.snapshot.queryParams['transactionNo'];
      let result: MerchantPaylinkPaymentResponse = await this.api.processSubAccountPaymentRequest(transactionNo, orderNumber);
      if (result) {
        await this.showToast(await this.translate.get('Payment operation completed').toPromise());
        setTimeout(() => {
          this.router.navigateByUrl('/private/sub-accounts').then();
        }, 3000);
      }
    } catch (e) {
      this.submitting = false;
      if (e.error.title) {
        this.showToast(await this.translate.get(e.error.title).toPromise());
      } else {
        this.showToast(await this.translate.get('The operation did not succeed. Please try again.').toPromise());
      }
      await this.router.navigateByUrl('/private/sub-accounts');
      this.submitted = false;
    }
  }

  showToast(msg) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

}
